import { render, staticRenderFns } from "./LawyerServicesAdd.vue?vue&type=template&id=346c8157&"
import script from "./LawyerServicesAdd.vue?vue&type=script&lang=js&"
export * from "./LawyerServicesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports